import { createHttpClient } from '@vista-digital/http-client';
import { getGlobalHeaders } from './get-global-headers';
import { getRequestConfig } from './get-request-config';
import { createRequestCache, getKeyForRequest } from './request-cache';
/**
 * Creates an [[HttpClient]] based on the provided [[CxmRulesClientConfig]].
 *
 * Each [[HttpClient]] method automatically handles authorisation errors by reloading the auth token.
 * The [[HttpClient.get]] method also prevents unnecessary duplicate API calls via a request cache.
 */
export const getHttpClient = (config) => {
    const httpClient = createHttpClient({
        baseUrl: config.url,
        credentials: 'omit',
        headers: getGlobalHeaders(),
        maxAttempts: config.maxAttempts,
        timeoutInMilliseconds: config.timeoutInMilliseconds
    });
    const withRequestCache = createRequestCache();
    return {
        delete: async (url, requestConfig) => {
            return httpClient.delete(url, await getRequestConfig(config, requestConfig));
        },
        get: async (url, requestConfig) => {
            return withRequestCache(async () => httpClient.get(url, await getRequestConfig(config, requestConfig)), getKeyForRequest(url, requestConfig));
        },
        head: async (url, requestConfig) => {
            return httpClient.head(url, await getRequestConfig(config, requestConfig));
        },
        post: async (url, body, requestConfig) => {
            return httpClient.post(url, body, await getRequestConfig(config, requestConfig));
        },
        put: async (url, body, requestConfig) => {
            return httpClient.put(url, body, await getRequestConfig(config, requestConfig));
        }
    };
};
//# sourceMappingURL=get-http-client.js.map